import { Container, Divider } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { Grid } from "@mui/material";
import axios from "axios";
import {
  ArrayChip,
  ButtonGroupTop,
  CustomTable,
  ModalError,
  ModalSuccess,
  Page,
  PrimaryButton,
  SearchTextInput,
  SectionLabel,
} from "components";
import { HeaderTitle } from "layouts";
import { getTotalPage } from "lib";
import { debounce } from "lodash";
import { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import { getErrors, textCapitalization } from "utils";

function Pajak() {
  const classes = globalStyles();
  const history = useHistory();
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const [loadingPage, setLoadingPage] = useState(true);
  const [dataTable, setDataTable] = useState([]);
  const [queryParams, setQueryParams] = useState({
    page: 1,
    per_page: 10,
    search: "",
  });
  const [tableTotalPage, setTableTotalPage] = useState(1);

  const handleChangeQueryParams = (value, key) => {
    setQueryParams(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
  };

  const getDataTable = async () => {
    try {
      setLoadingPage(true);
      const res = await axios.get(`${hardBaseUrl}/tax/datatable`, {
        headers,
        params: queryParams,
      });

      const { data, meta } = res?.data;
      setDataTable(data || []);
      const pageCount = getTotalPage(meta?.found, queryParams?.per_page || 1);
      setTableTotalPage(pageCount);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };
  const debounceDataTable = useCallback(
    debounce(() => {
      getDataTable();
    }, 500),
    [queryParams]
  );
  const deleteTax = async item => {
    try {
      setLoadingPage(true);
      await axios.delete(`${hardBaseUrl}/tax/delete/${item?.id}`, {
        headers,
      });
      ModalSuccess("Tax Deleted Sucesfully").then(() => getDataTable());
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };

  useEffect(() => {
    debounceDataTable();
    return () => {
      debounceDataTable.cancel();
    };
  }, [queryParams, debounceDataTable]);

  return (
    <Page className={classes.root} title="Tax">
      <Container maxWidth={false}>
        <HeaderTitle title="Configuration" breadcrumbData={breadcrumbData} />
        <ButtonGroupTop />
        <Divider className={classes.flatDivider} />
        <SectionLabel
          title="Tax"
          subTitle="This feature is used to settings and manage Client's Tax"
          mt="16px"
        />
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          my="16px"
        >
          <Grid item>
            <SearchTextInput
              placeholder="Search"
              value={queryParams?.search}
              onChange={e =>
                handleChangeQueryParams(e?.target?.value, "search")
              }
              disabled={loadingPage}
            />
          </Grid>
          <Grid item>
            <PrimaryButton
              label="Add Tax"
              onClick={() => history.push("/admin/konfigurasi/pajak/add")}
              startIcon={<Add />}
              size="large"
              disabled={loadingPage}
            />
          </Grid>
        </Grid>
        <CustomTable
          isLoading={loadingPage}
          columnTable={columnTable}
          data={dataTable}
          page={queryParams?.page}
          pageSize={queryParams?.per_page}
          pageCount={tableTotalPage}
          handleChangePage={(_, page) => handleChangeQueryParams(page, "page")}
          handleChangePageSize={e =>
            handleChangeQueryParams(e?.target?.value, "per_page")
          }
          isHaveAction
          handleEdit={item =>
            history.push(`/admin/konfigurasi/pajak/edit/${item.id}`)
          }
          handleDelete={item => deleteTax(item)}
          deleteConfirmation
          deleteConfirmationTitle="Delete Tax"
          deleteConfirmationKey="code"
        />
      </Container>
    </Page>
  );
}
const breadcrumbData = [
  {
    label: "Home",
    link: "/admin/dashboard",
  },
  {
    label: "Configuration",
    link: "/admin/konfigurasi/pajak",
  },
  {
    label: "Tax",
    active: true,
  },
];

const columnTable = [
  {
    name: "code",
    title: "Code",
  },
  {
    name: "description",
    title: "Description",
  },
  {
    name: "rate",
    title: "Rate",
    renderText: item => `${item} %`,
  },
  {
    name: "tax_bases",
    title: "Bases",
    renderText: item => `${item} %`,
  },
  {
    name: "method",
    title: "Method",
    renderText: item => textCapitalization(item),
  },
  {
    name: "tax_objects",
    title: "Object",
    renderText: tax_objects => {
      const modifiedItems = (tax_objects || [])?.map(
        ({ tax_object, ...rest }) => ({
          ...rest,
          name: textCapitalization(tax_object) || "-",
        })
      );
      return <ArrayChip list={modifiedItems} max={3} />;
    },
  },
];

export default Pajak;
